import { memo, useEffect, useState } from "react";
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import ThemeSwitcher from "../toggle/DarkModeToggle";
import Loader from "../common/Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { consoleLog, errorLog } from "../../services/consoleLog";
import { navigation } from "../../static-data/navigation";
import { getMethod } from "../../store/api-services/api-methods";
import ProductToggle from "../toggle/ProductToggle";
import { clearSessionStorage } from "@/services/sessionService";
import { clearLocalStoage, getLocalStorage, removeLocalStorage } from "@/services/localSessionService";
import ConfirmModal from "../common/Modals/ConfirmModal";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}
const Header = () => {
  const location = useLocation();
  const pathname = location.pathname;
  consoleLog("Location =>", location);
  const mySplitPath = pathname.split("/");
  // const activePath = "dashboard";
  const activePath = mySplitPath.length > 2 ? (mySplitPath[2] == "" ? "dashboard" : mySplitPath[2]) : "dashboard";
  const router = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [menuNavigation, setMenuNavigation] = useState<any>([]);
  const [userName, setUserName] = useState<any>("VBtron");
  const [userRole, setUserRole] = useState<any>("User");
  const [isClear, setIsClear] = useState<boolean>(false);

  const loggedOutMe = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      removeLocalStorage("accessToken");
      removeLocalStorage("isLogin");
      const responseInfo = await getMethod("/api/v1/logout");
      const userJson = await responseInfo.json();
    } catch (err) {
      errorLog("Error : ", err);
    } finally {
      setIsLoading(false);
      router("/");
    }
  };

  useEffect(() => {
    const userData = JSON.parse(getLocalStorage("user")!);
    const user_role = getLocalStorage('user_role') ? getLocalStorage('user_role') : "Production";
    setUserRole(user_role);
    const user_name = userData ? userData.name : "VBtron";
    setUserName(user_name);
    const menuNavigate = navigation?.[user_role!] || [];
    setMenuNavigation(menuNavigate);
  }, []);

  const clearSession = (respo: any) => {
    if(respo === 'confirm'){
      clearSessionStorage();
      clearLocalStoage();
      router("/");
    }
    setIsClear(false);
  }

  return (
    <>
    {isClear && (
        <ConfirmModal action={clearSession}>
          <span>Are you sure to reset system?</span>
          <br />
          <strong>[Once you accept to reset system, all system has been clear and logout.]</strong>
        </ConfirmModal>
    )}
    <Disclosure as="nav" className="bg dark:bg-cta">
      {({ open }) => (
        <>
          <div className="mx-auto sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="absolute -inset-0.5"></span>
                  <span className="sr-only">Open main menu</span>
                  {open ? <XMarkIcon className="block h-6 w-6" aria-hidden="true" /> : <Bars3Icon className="block h-6 w-6" aria-hidden="true" />}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                {/* <div className="flex flex-shrink-0 items-center">
                  <Link to={"/app"}>
                    <img className="w-auto pr-10 max-w-[275px]" src="/assets/images/logo.png" alt="VBtron Apps" width={123} height={32} />
                  </Link>
                </div>*/}
                <div className="hidden sm:block top-menu">
                  <div className="flex space-x-4 items-center h-full menu-items">
                    {menuNavigation.map((item: any) => (
                      <div key={item.name} className={classNames(activePath === item.href ? "bg-primaryDark text-white" : "text-white hover:bg-primaryDark hover:text-white", "h-12 px-2 text-sm font-medium flex flex-shrink-0 items-center relative", item.submenu ? "menu-items-children" : "")} aria-current={activePath === item.href ? "page" : undefined}>
                        <span className="cursor-pointer">
                          {(item?.submenu && item.href !== 'dashboard') ? (
                            <>
                              <span>{item.name}</span>
                              <svg className="h-4 w-4 inline text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                {" "}
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </>
                          ) : (
                            <Link to={`/app/${item.href == "dashboard" ? "" : item.href}`}>{item.name}</Link>
                          )}
                        </span>
                        {item?.submenu && (
                          <div className="subMenu hidden bg-primaryDark text-white">
                            <ul>
                              {item?.submenu.map((subitem: any, index: any) => (
                                <li key={index}>
                                  <div className={classNames("block hover:bg-primary", subitem.submenu ? "menu-items-children" : "")}>
                                    <span className="flex items-center">
                                      <Link className="px-4 py-2 block" to={`/app/${item.href != "" ? item.href + "/" : ""}${subitem.href}`}>
                                        {subitem.name}{" "}
                                      </Link>
                                      {subitem?.submenu && (
                                        <svg className="h-4 w-4 inline text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                          {" "}
                                          <polyline points="6 9 12 15 18 9" />
                                        </svg>
                                      )}
                                    </span>
                                    {subitem?.submenu && (
                                      <div className="subMenuSecondary hidden bg-primaryDark">
                                        <ul>
                                          {subitem?.submenu.map((subitem1: any, index: any) => (
                                            <li key={index} className="hover:bg-primary">
                                              <Link to={`/app/${item.href != "" ? item.href + "/" : ""}${subitem.href != "" ? subitem.href + "/" : ""}${subitem1.href}`} className="px-4 py-2 block">
                                                {subitem1.name}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <ProductToggle />
                {/* <ThemeSwitcher /> */}
                {/* <button type="button" className="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button> */}
                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="relative min-w-[33px] flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="absolute -inset-1.5" />
                      <span className="sr-only">Open user menu</span>
                      <img className="h-8 w-8 rounded-full" src="/assets/images/user-icon.png" alt="" width={61} height={61} />
                    </Menu.Button>
                  </div>
                  <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-52 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item>
                        <div className="flex px-4 py-2 bg-primaryDark items-center gap-4">
                          <img className="w-10 h-10 rounded-full" src="/assets/images/user-icon.png" alt="Avatar" height={61} width={61} />
                          <div className="font-medium text-white">
                            <div>{userName}</div>
                            <div className="text-sm text-gray-400 dark:text-gray-400">{userRole}</div>
                          </div>
                        </div>
                      </Menu.Item>
                      {userRole === 'Admin' && 
                        <>
                          <Menu.Item>
                            {({ active }) => (
                              <Link to={"/app/users/user-role"} className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                User Roles
                              </Link>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <Link to={"/app/users/users"} className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                User Management
                              </Link>
                            )}
                          </Menu.Item>
                        </>
                      }
                      {/* <Menu.Item>
                        {({ active }) => (
                          <Link to={"/app/users/settings"} className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                            Settings
                          </Link>
                        )}
                      </Menu.Item> */}
                      <Menu.Item>
                        {({ active }) => (
                          <a href="#" onClick={() => setIsClear(true)} className={classNames(active ? "bg-gray-100" : "", " cursor-pointer block px-4 py-2 text-sm text-gray-700")}>
                            Reset System
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a href="#" onClick={loggedOutMe} className={classNames(active ? "bg-gray-100" : "", " cursor-pointer block px-4 py-2 text-sm text-gray-700")}>
                            Sign out
                          </a>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
          {isLoading && (
            <div className="z-30 left-0 right-0 top-0 bottom-0 px-4 py-2 absolute items-center justify-center bg-white rounded-lg opacity-[0.95]">
              <div className="h-full px-4 py-2 flex items-center justify-center">
                <Loader>
                  <div className="p-3">Wait! We are logging out...</div>
                </Loader>
              </div>
            </div>
          )}
          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {menuNavigation.map((item: any) => (
                <Disclosure.Button key={item.name} as="a" href={item.href} className={classNames(activePath === item.href ? "bg-gray-900 text-white" : "text-gray-300 hover:bg-gray-700 hover:text-white", "block rounded-md px-3 py-2 text-base font-medium text-l")} aria-current={activePath === item.href ? "page" : undefined}>
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
    </>
  );
};

export default memo(Header);
